import { Fragment } from 'react';
import Tooltip from 'components/TooltipV2';
import Icon from 'components/icons';
import type { ICustomContentMetric } from 'services/customContent';
import { formatCustomContentMetricValue, getMetricTooltip } from '../utils';
import {
  MetricDivider,
  MetricInfoIcon,
  MetricLabel,
  MetricLabelGroup,
  MetricRow,
  MetricValue,
  MetricsPanel,
  MetricsTitle,
  MetricsTitleIcon,
  MetricsTitleWrapper,
} from './CustomContentCard.styles';

interface ICustomContentMetricsProps {
  metrics?: ICustomContentMetric[];
  contentType?: string;
  title?: string;
}

const CustomContentMetrics = ({
  metrics,
  contentType,
  title,
}: ICustomContentMetricsProps): JSX.Element | null => {
  if (!metrics?.length) {
    return null;
  }

  return (
    <MetricsPanel data-testid="custom-content-metrics-panel">
      {title && (
        <>
          <MetricsTitleWrapper>
            <MetricsTitleIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9.333"
                height="12"
                viewBox="0 0 10 12"
                fill="none"
                style={{ flexShrink: 0 }}
              >
                <path
                  d="M9.33333 12L4.66667 8.66667L0 12V1.33333C0 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979712 0 1.33333 0H8C8.35362 0 8.69276 0.140476 8.94281 0.390524C9.19286 0.640573 9.33333 0.979711 9.33333 1.33333V12Z"
                  fill="white"
                />
              </svg>
            </MetricsTitleIcon>
            <MetricsTitle>{title}</MetricsTitle>
          </MetricsTitleWrapper>
          <MetricDivider />
        </>
      )}
      {metrics.map((metric, index) => {
        const tooltip = getMetricTooltip(metric.key, contentType);

        return (
          <Fragment key={metric.key}>
            <MetricRow>
              <MetricLabelGroup>
                {tooltip && (
                  <Tooltip content={tooltip} placement="topRight">
                    <MetricInfoIcon type="button" aria-label={`${metric.label} metric information`}>
                      <Icon
                        icon="Info"
                        fill="#A793F6"
                        size="small"
                        aria-hidden="true"
                        style={{ width: '14px', height: '14px' }}
                      />
                    </MetricInfoIcon>
                  </Tooltip>
                )}
                <MetricLabel>{metric.label}:</MetricLabel>
              </MetricLabelGroup>
              <MetricValue>{formatCustomContentMetricValue(metric)}</MetricValue>
            </MetricRow>
            {index < metrics.length - 1 && <MetricDivider />}
          </Fragment>
        );
      })}
    </MetricsPanel>
  );
};

export default CustomContentMetrics;
